import * as React from "react"
const PhoneCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={"1em"}
    height={"1em"}
    viewBox={"0 0 19 19"}
    fill="none"
    {...props}
  >
    <g clipPath="url(#mob_a)">
      <path
        fill="currentColor"
        d="M16.216 2.781A9.5 9.5 0 1 0 2.784 16.218 9.5 9.5 0 0 0 16.217 2.781Zm-1.829 10.452v.001-.003l-.482.478c-.623.63-1.53.89-2.391.684a8.42 8.42 0 0 1-2.445-1.095 11.296 11.296 0 0 1-1.928-1.555A11.384 11.384 0 0 1 5.7 9.995a8.865 8.865 0 0 1-1.083-2.191 2.533 2.533 0 0 1 .633-2.588l.564-.563a.402.402 0 0 1 .569-.001h.001l1.78 1.78a.402.402 0 0 1 0 .57L7.119 8.047a.852.852 0 0 0-.089 1.109 12.22 12.22 0 0 0 1.25 1.46c.508.509 1.059.972 1.647 1.383a.858.858 0 0 0 1.096-.095l1.01-1.025a.402.402 0 0 1 .569-.002l.001.002 1.783 1.786a.402.402 0 0 1 .001.568Z"
      />
    </g>
    <defs>
      <clipPath id="mob_a">
        <path fill="#fff" d="M0 0h19v19H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default PhoneCircleIcon
